export class ItemParams {
  private item_name: string | null = null;
  private item_id: string | null = null;
  private item_brand: string | null = null;
  private item_category: string | null = null;
  private item_category2: string | null = null;
  private item_category3: string | null = null;
  private item_category4: string | null = null;
  private item_category5: string | null = null;
  private item_variant: string | null = null;
  private currency: string | null = null;
  private price: string | null = null;
  private coupon: string | null = null;
  private discount: string | null = null;
  private quantity: string | null = null;
  private affiliation: string | null = null;
  private marketing_tag_name: string | null = null;

  constructor(hotel: any, producto: string, destination: any, position?: number) {
    if (hotel !== undefined) {
      if (producto === 'alojamiento') {
        this.loadAlojamiento(hotel, producto, destination);
      } else {
        this.loadDisneyUNiversal(hotel, producto);
      }

      this.item_id = hotel.id;
      this.currency =
        hotel.rate !== undefined ? (hotel.rate.price.currency.code as string).toLowerCase() : null;
      this.marketing_tag_name = position !== undefined ? String(position) : null;
    }
  }

  public loadAlojamiento(hotel, producto, destination) {
    this.item_name = (destination.city.name as string).toLocaleLowerCase();
    this.item_brand = (hotel.name as string).toLocaleLowerCase();
    this.item_category = `${producto} / ${destination.country.name} / ${destination.city.name}`.toLocaleLowerCase();
    this.price =
      hotel.rate !== undefined
        ? hotel.rate.price.total
        : hotel.price !== undefined
        ? hotel.price
        : null;
  }

  public loadDisneyUNiversal(hotel, producto) {
    this.item_name = (hotel.name as string).toLocaleLowerCase();
    this.item_category = `${producto}`.toLocaleLowerCase();
    this.item_category5 = hotel.stars;
    this.price = hotel.rate.price.total_without_discount;
  }

  public getData(producto) {
    let data = {};
    if (producto === 'alojamiento') {
      data = {
        item_name: this.item_name,
        item_id: this.item_id,
        item_brand: this.item_brand,
        item_category: this.item_category,
        item_category2: this.item_category2,
        item_category3: this.item_category3,
        item_category4: this.item_category4,
        item_category5: this.item_category5,
        item_variant: this.item_variant,
        currency: this.currency,
        price: this.price,
        coupon: this.coupon,
        discount: this.discount,
        quantity: this.quantity,
        affiliation: this.affiliation,
        marketing_tag_name: this.marketing_tag_name,
      };
    } else {
      data = {
        item_name: this.item_name,
        item_id: this.item_id,
        item_category: this.item_category,
        item_category2: this.item_category2,
        item_category3: this.item_category3,
        item_category4: this.item_category4,
        item_category5: this.item_category5,
        item_variant: this.item_variant,
        currency: this.currency,
        price: this.price,
        coupon: this.coupon,
        discount: this.discount,
        quantity: this.quantity,
        affiliation: this.affiliation,
        marketing_tag_name: this.marketing_tag_name,
      };
    }

    return data;
  }
}
